import {
  Component, OnInit, HostListener, Input, Output,
  ElementRef, ViewChild, ChangeDetectionStrategy,
  ChangeDetectorRef, AfterViewChecked, EventEmitter
} from '@angular/core';
import {
  FilterSettingsModel, GridComponent, ToolbarItems,
  RowSelectEventArgs, RowDeselectEventArgs, VirtualScrollService, parentsUntil,
  PageSettingsModel,
  Column
} from '@syncfusion/ej2-angular-grids';
// import { setSpinner } from '@syncfusion/ej2-angular-popups';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
// import { DataUtil } from '@syncfusion/ej2-data';
import * as L from 'leaflet';

import {
  DelayedAction,
  ApplicationStatus,
  GridPayload,
  GridSelectLayer,
  SetGridRasterHighlight,
  RefreshDisplayedGeoJson,
  DelayedActionBy1,
  ToastUserNotification
} from 'src/app/state-management';

import {
  LayerState,
  DnvFeatureLayer,
  ZoomToFeatures,
  Layer as DnvLayer,
  LayerType, isLayerFilterActive, CheckMarkerPosition
} from 'dnv-lib';
import { Action } from '@ngrx/store';

@Component({
    selector: 'app-grid-view',
    templateUrl: './grid-view.component.html',
    styleUrls: ['./grid-view.component.scss'],
    providers: [VirtualScrollService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GridViewComponent implements OnInit, AfterViewChecked {
  @Input() layerState: LayerState = null;
  @Input() applicationStatus: ApplicationStatus;
  @Input('selectedLayer') set selectedLayer(value: DnvFeatureLayer) {
    this.tabSelectedLayer = value;
    this.updateGrid();
  }
  @Input('gridData') set gridData(value: Map<string, GridPayload>) {
    this.gridDataCache = value;
    this.updateGrid();
  }

  @Output() selectLayer = new EventEmitter<DnvFeatureLayer>();
  @Output() gridViewUpdate = new EventEmitter<Action>();
  @Output() closeGridEmitter = new EventEmitter<any>();

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('layerslist', { static: false }) public layerslist: ElementRef<any>;
  @ViewChild('listwrapper', { static: false }) public listwrapper: ElementRef<any>;

  public data: object[] = [];
  public geometry: object[] = [];
  public columns: object[] = [];
  public tabSelectedLayer: DnvFeatureLayer = null;
  public gridDataCache: Map<string, GridPayload> = null;
  public filterOptions: FilterSettingsModel;
  // public selectOneLayer = false;
  public toolbarOptions: ToolbarItems[];
  public showGridComponent = false;
  public pageSettings: PageSettingsModel = { pageSize: 50 };
  public objectid: string = 'OBJECTID';
  public objectidclean: string = 'OBJECTID';

  constructor(
  ) {
  }

  ngOnInit(): void {

    this.data = [];
    this.geometry = [];
    this.columns = [];
    this.toolbarOptions = ['ColumnChooser', 'ExcelExport', 'CsvExport'];
    this.filterOptions = {
      type: 'Menu'
    };

  }

  ngAfterViewChecked(): void {
    // if (this.applicationStatus === ApplicationStatus.Table) {
    //   if (this.selectOneLayer === false && this.layerCount() >= 1) {
    //     // console.log(this.activeLayers());
    //     this.selectLayer.emit(this.activeLayers()[0]);
    //     this.selectOneLayer = true;
    //   }
    // }
  }

  // enableVirtualization(): boolean {
  //   return this.data.length > 100;
  // }

  isLayerFiltered(featureLayer: DnvFeatureLayer): boolean {
    return isLayerFilterActive(featureLayer);
  }

  activeLayers(): DnvFeatureLayer[] {
    if (this.layerState) {
      return this.layerState.layers
        .filter(layer => layer.type === LayerType.Active)
        .map(layer => layer.featureLayers)
        .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []); // Poor man's FlatMap
    } else {
      return [];
    }
  }

  updateGrid(): void {
    this.showGridComponent = false;
    this.data = [];
    this.columns = [];

    if (this.tabSelectedLayer && this.gridDataCache.has(this.tabSelectedLayer.uid)) {
      const gridPayload: GridPayload = this.gridDataCache.get(this.tabSelectedLayer.uid);
      this.columns = gridPayload.fieldAliases.map((f: any[]) => {
        const fieldOptions: any = {
          field: f[0],
          headerText: this.replaceUnderscore(f[1]),
          width: 'auto',
          clipMode: 'EllipsisWithTooltip',
          textAlign: 'Left',
          minWidth: 110,
          maxWidth: 300,
          // type: f[2] === 'esriFieldTypeDate' ? 'dateTime' : '',
          // format: f[2] === 'esriFieldTypeDate' ?'yyyy-MM-dd': ''
        };
        if (f[2] === 'esriFieldTypeDate') {
          fieldOptions.type = 'date';
          fieldOptions.format = 'yyyy-MM-dd'; // { format: 'yyyy-MM-dd', type: 'date' };
        }
        return fieldOptions;

      });
      const subTypes = this.tabSelectedLayer.subTypes;
      if (subTypes) {
        gridPayload.data.map((d: any) => {
          const typeName = subTypes.find(s => s.id === d.AM_Type);
          if (typeName) {
            d.AM_Type = typeName.name;
          }
        });
      }

      // format length & area
      gridPayload.data.map((d: any) => {
        // console.log(d);
        // format length
        const lengthFields = ['shape_stlength()', 'inv_elev', 'manhole_rim_elev', 'manhole_entry_size', 'offset', 'asb_length', 'asb_slope', 'calc_slope', 'up_elev', 'dn_elev', 'conn_chain', 'pty_offset', 'am_diameter', 'am_rise', 'am_span', 'flume_up_elev', 'flume_dn_elev', 'flume_asb_length', 'flume_asb_slope', 'cl_length', 'bf_length', 'sw_length', 'totallength', 'totalarea', 'totalwidth'];
        for (var key in d) {
          if (d.hasOwnProperty(key)) {
            // console.log(key + " -> " + p[key]);
            if (lengthFields.includes(key.toLowerCase())) {
              if (d[key] && Number(d[key])) {
                // console.log(key, d[key]);
                if (Number(d[key]) === -99) {
                  d[key] = 'UNKNOWN';
                }
                else if (key.toLowerCase().indexOf('size') > -1) {
                  d[key] = Number(d[key]).toFixed(2);
                } else {
                  d[key] = Number(d[key]).toFixed(2);
                }

                // d[key] = d[key].toFixed(2) + ' m';
              }
            }

            if (Number(d[key]) === -99) {
              d[key] = 'UNKNOWN';
            }
          }
        }

        // if (d['SHAPE_STLength()'] && Number(d['SHAPE_STLength()'])) {
        //   d['SHAPE_STLength()'] = d['SHAPE_STLength()'].toFixed(2) + ' m';
        // } else if (d['Shape_STLength()'] && Number(d['Shape_STLength()'])) {
        //   d['Shape_STLength()'] = d['Shape_STLength()'].toFixed(2) + ' m';
        // }

        // format area
        if (d['SHAPE_STArea()'] && Number(d['SHAPE_STArea()'])) {
          d['SHAPE_STArea()'] = d['SHAPE_STArea()'].toFixed(2) + ' m<sup>2</sup>';
        } else if (d['Shape_STArea()'] && Number(d['Shape_STArea()'])) {
          d['Shape_STArea()'] = d['Shape_STArea()'].toFixed(2) + ' m<sup>2</sup>';
        } else if (d['DeckArea'] && Number(d['DeckArea'])) {
          d['DeckArea'] = d['DeckArea'].toFixed(2) + ' m<sup>2</sup>';
        }

      });

      this.data = gridPayload.data;
      this.geometry = gridPayload.geometry;
      this.objectid = gridPayload.objectid;
      this.objectidclean = gridPayload.objectidclean;
      this.dataBound = this.dataBound;
      // this.grid.dataSource = this.data;
      // this.grid.refresh();

      // setTimeout(() => { this.showGridComponent = true; }, 0);
      this.showGridComponent = true;
    }

  }


  onGridDestroy(e: any): void {
    console.log('onGridDestroy');
  }


  layerCount(): number {
    return this.activeLayers().length;
  }

  public gridCreated(): void {
    // setSpinner({ type: 'Bootstrap' });
    this.grid.showSpinner();
    for (const col of this.grid.columns) {
      if ((col as Column).headerText === 'Area' || (col as Column).headerText === 'Deck Area') {
        (col as Column).disableHtmlEncode = false;
      }
    }
  }

  displayInGrid(layer: DnvFeatureLayer): void {
    // this.selectLayer.emit(layer);
    this.gridViewUpdate.emit(new GridSelectLayer({ dnvFeatureLayer: null }));
    this.gridViewUpdate.emit(new DelayedAction([new GridSelectLayer({ dnvFeatureLayer: layer })]));
  }

  layerSelected(): boolean {
    if (this.tabSelectedLayer && this.columns.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  selected(layerUid: string): boolean {
    let s = false;
    if (this.tabSelectedLayer) {
      s = layerUid === this.tabSelectedLayer.uid;
    }
    return s;
  }



  dataBound(): void {
    this.grid.autoFitColumns();
    /*for (const cols of this.grid.columns) {
      if ((cols as any).field === 'DateCapped') {
        (cols as any).type = 'date';
        (cols as any).format = 'MM/dd/yyyy hh:mm:ss a';
      }
    }*/
  }

  replaceUnderscore(input: string): string {
    return input.replace('_', ' ');
  }

  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id.indexOf('excelexport') > -1) {
      this.grid.excelExport();
    }
    if (args.item.id.indexOf('csvexport') > -1) {
      this.grid.csvExport();
    }
    if (args.item.id.indexOf('columnchooser') > -1) {
      setTimeout(() => { (document.querySelector('input.e-ccsearch.e-cc.e-input') as HTMLElement).blur(); }, 5);
    }
  }
  scrollLeft(): void {
    this.layerslist.nativeElement.scrollLeft -= 200;
  }

  scrollRight(): void {
    this.layerslist.nativeElement.scrollLeft += 200;
  }

  clearGrid(): void {
    // this.selectLayer.emit(null);
    this.gridViewUpdate.emit(new GridSelectLayer({ dnvFeatureLayer: null }));
  }

  closeGrid(): void {
    this.closeGridEmitter.emit();
  }

  // From https://stackblitz.com/edit/angular-hjfcyi?file=app.component.ts
  load(args: any): void {
    this.grid.element.addEventListener('mouseover', (e) => {
      if ((e.target as HTMLElement).classList.contains('e-rowcell')) {
        const ele: Element = e.target as Element;
        const row = parentsUntil(ele, 'e-row');
        const rowindex = row.getAttribute('aria-rowindex');

        if (rowindex) {

          const index = Number(rowindex);
          if (this.data.length > 0 && index < this.data.length) {

            const rowData: any = this.grid.getRowsObject().find(obj => obj.index === index).data;

            if (rowData.hasOwnProperty(this.objectidclean)) {

              if (this.tabSelectedLayer) {
                const rdIndex = this.data.findIndex(d => d === rowData);
                let errorMsg = 'We could not highlight feature ' + rowData[this.objectidclean] + ' from layer ' + (this.tabSelectedLayer as any).displayName;;
                if (rowData['Asset_Id'] && rowData['Asset_Id'].length > 0) {
                  errorMsg = 'We could not highlight feature ' + rowData['Asset_Id'] + ' from layer ' + (this.tabSelectedLayer as any).displayName;
                }

                // Point, LineString, Polygon, MultiPoint, MultiLineString, and MultiPolygon
                const geometry: any = this.geometry[rdIndex];
                let g: any = {};
                if (geometry.paths) {
                  if (geometry.paths.length > 1) {
                    // console.error('MultiLineString ???', this.tabSelectedLayer);

                    g = {
                      coordinates: geometry.paths,
                      type: 'MultiLineString'
                    };

                    this.gridViewUpdate.emit(new ToastUserNotification({
                      type: 'error',
                      title: '',
                      message: errorMsg,
                      options: {}
                    }));
                    return;

                  } else {
                    // console.error('LineString ???', this.tabSelectedLayer);

                    g = {
                      coordinates: geometry.paths[0], // [[-123.08229262057958, 49.336111890577946], [-123.08219439549659, 49.33611220333603]], // data.geometries[0].rings, 
                      type: 'LineString' // 'Polygon' // Could be MultiPolygon if f.geometry.rings has more than one ring?
                    };
                  }
                } else if (geometry.rings) {
                  if (geometry.rings.length > 1) {
                    // console.error('MultiPolygon ???', this.tabSelectedLayer);
                    let rings = geometry.rings as Array<Array<Array<number>>>;
                    g = {
                      coordinates: rings.map(r => [r]),
                      type: 'MultiPolygon'
                    };
                  } else {
                    // console.error('Polygon ???', this.tabSelectedLayer);

                    g = {
                      coordinates: geometry.rings,
                      type: 'Polygon'
                    };

                  }

                } else {
                  if (geometry.length > 1) {
                    // console.error('MultiPoint ???', this.tabSelectedLayer);

                    g = {
                      coordinates: geometry,
                      type: 'MultiPoint'
                    };

                    this.gridViewUpdate.emit(new ToastUserNotification({
                      type: 'error',
                      title: '',
                      message: errorMsg,
                      options: {}
                    }));
                    return;

                  } else {
                    // console.error('Point ???', this.tabSelectedLayer);

                    g = {
                      coordinates: [geometry.x, geometry.y],
                      type: 'Point'
                    };

                  }

                }


                this.gridViewUpdate.emit(
                  new SetGridRasterHighlight(
                    {
                      url: 'MailMergeBufferGeometry' + new Date().toISOString(), // create a unique url
                      json: {
                        features: [{
                          geometry: g,
                          type: 'Feature'
                        }]
                      },
                      style: {
                        fillColor: '#222222',
                        weight: 5,
                        opacity: 0.6,
                        color: '#ff9900',
                        dashArray: '8',
                        fillOpacity: 0.4
                      }
                    }
                  )
                );
                this.gridViewUpdate.emit(
                  new DelayedAction([new RefreshDisplayedGeoJson()])
                );

              }

            } else {
              console.log('Asset_Id not found in data', rowData);
            }
          }
        }
      }
    }
    );

    this.grid.element.addEventListener('mouseleave', (e) => {

      this.gridViewUpdate.emit(new SetGridRasterHighlight({}));
      this.gridViewUpdate.emit(
        new DelayedAction([new RefreshDisplayedGeoJson()])
      );

    }
    );
  }

  rowSelected(args: RowSelectEventArgs | RowDeselectEventArgs): void {
    const rowData: any = args.data;
    if (rowData.hasOwnProperty(this.objectidclean)) { // Assert the OBJECTID is available
      if (this.tabSelectedLayer) {
        const url = this.tabSelectedLayer.url;
        const whereClause = this.tabSelectedLayer.whereClause;

        if (this.tabSelectedLayer) {

          const dnvFeatureLayer: DnvFeatureLayer = Object.assign({}, this.tabSelectedLayer, {
            whereClause: this.objectid + '=' + rowData[this.objectidclean]
          });

          this.gridViewUpdate.emit(new ZoomToFeatures([dnvFeatureLayer]));

          if (rowData.hasOwnProperty(this.objectidclean)) {
            const rdIndex = this.data.findIndex(d => d === rowData);

            // pan map up to show feature
            const coords = this.geometry[rdIndex] as any;
            let aPoint;

            if (coords.x) {
              aPoint = [coords.y, coords.x];
            } else if (coords.paths) {
              aPoint = [coords.paths[0][0][1], coords.paths[0][0][0]];
            } else if (coords.rings) {
              aPoint = [coords.rings[0][0][1], coords.rings[0][0][0]];
            }
            const markerOpts = {
              latlng: aPoint,
              hSpace: 100,
              vSpace: 300,
              unit: 'pixel', // percentage or pixel (default)
              direction: 'top'
            };
            this.gridViewUpdate.emit(new DelayedActionBy1([new CheckMarkerPosition(markerOpts)]));
          }

        }
      }

    } else {
      console.log(this.objectidclean + ' not found in data', rowData);
    }

  }

  rowDeSelected(args: RowDeselectEventArgs): void {
    const rowData: any = args.data;
  }

}
